import { Button, Flex, Form, Grid } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Clock from "../../../../assets/images/icons/Clock";
import LocationDemo from "../../../../assets/images/icons/LocationDemo";
import SkiDemo from "../../../../assets/images/icons/SkiDemo";
import UserDemo from "../../../../assets/images/icons/UserDemo";
import {
  CountDropdown,
  ResortDropdown,
  SessionTypeSelector,
  SkillSelector,
} from "../../../../components";
import { pushGtag } from "../../../../plugins/utils";
import { InputRequired } from "../../../../validations/validations";
import { OtherFilterProps } from "../../data";

const OtherFilter = ({
  form,
  coachInfo,
  params,
  setOpen,
  studentLimit,
  setStudentLimit,
}: OtherFilterProps) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [showHalfDaySelector, setShowHalfDaySelector] = useState(false);

  const handleCancel = () => {
    pushGtag({
      event: "book_coach_cancel",
    });

    setOpen(false);
  };

  return (
    <Flex vertical gap={16}>
      <Flex align="center" gap={12}>
        <SkiDemo
          style={{
            fontSize: screens.sm ? 32 : 20,
            color: "var(--Neutral-dark-50)",
            minWidth: screens.sm ? 32 : 20,
          }}
        />
        <Form.Item
          style={{ marginBottom: 0, flex: 1 }}
          name={"skill_type"}
          label={t("normal.skill.title")}
          rules={[InputRequired(t, "normal.skill.title")]}
          className="filter-form-item"
        >
          <SkillSelector form={form} skillCode={coachInfo?.skill_codes} />
        </Form.Item>
      </Flex>
      <Flex align="center" gap={12}>
        <LocationDemo
          style={{
            fontSize: screens.sm ? 32 : 20,
            color: "var(--Neutral-dark-50)",
            minWidth: screens.sm ? 32 : 20,
          }}
        />
        <Form.Item
          style={{ marginBottom: 0, flex: 1 }}
          name={"locations"}
          label={t("home.searchbar.resort.title")}
          rules={[InputRequired(t, "home.searchbar.resort.title")]}
          className="filter-form-item"
        >
          <ResortDropdown
            form={form}
            skiResortCode={coachInfo?.ski_resort_codes}
            setShowHalfDaySelector={setShowHalfDaySelector}
            setStudentLimit={setStudentLimit}
          />
        </Form.Item>
      </Flex>
      {showHalfDaySelector && (
        <Flex align="center" gap={12}>
          <Clock
            style={{
              fontSize: screens.sm ? 32 : 20,
              color: "var(--Neutral-dark-50)",
              minWidth: screens.sm ? 32 : 20,
            }}
          />
          <Form.Item
            name={"session_type"}
            label={t("normal.sessionType")}
            rules={[InputRequired(t, "normal.sessionType")]}
            className="filter-form-item"
            style={{ marginBottom: 0, flex: 1 }}
          >
            <SessionTypeSelector form={form} />
          </Form.Item>
        </Flex>
      )}
      <Flex align="center" gap={12}>
        <UserDemo
          style={{
            fontSize: screens.sm ? 32 : 20,
            color: "var(--Neutral-dark-50)",
            minWidth: screens.sm ? 32 : 20,
          }}
        />
        <Form.Item
          name={"count"}
          required
          label={t("normal.count.title")}
          style={{ marginBottom: 0, flex: 1 }}
          className="filter-form-item"
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (
                  Number(getFieldValue("adults")) === 0 &&
                  Number(getFieldValue("kids")) === 0
                )
                  return Promise.reject(
                    new Error(
                      t("form.required", { name: t("normal.count.title") })
                    )
                  );
                return Promise.resolve();
              },
            }),
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (
                  Number(getFieldValue("adults")) +
                    Number(getFieldValue("kids")) >
                  studentLimit
                ) {
                  return Promise.reject(
                    new Error(
                      t("home.filter.count.error", { limit: studentLimit })
                    )
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <CountDropdown
            form={form}
            params={params}
            studentLimit={studentLimit}
          />
        </Form.Item>
      </Flex>
      <Form.Item hidden name={"adults"} initialValue={0} />
      <Form.Item hidden name={"kids"} initialValue={0} />
      <Flex gap={8} justify="flex-end">
        <Button onClick={handleCancel} style={{ height: screens.md ? 48 : 36 }}>
          {t("normal.cancel")}
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          style={{ height: screens.md ? 48 : 36 }}
        >
          {t("normal.nextstep")}
        </Button>
      </Flex>
    </Flex>
  );
};

export default OtherFilter;
